import { fetchAndCache } from '../storage/media-cache.js';
import { getProgram, getCurrentSlotIdx } from '../state/program-store.js';
import { logWarn } from '../state/log-store.js';

export async function preloadNext() {
  const program = getProgram();
  if (!program?.slots?.length) return;
  const idx = getCurrentSlotIdx();
  const nextIdx = (idx + 1) % program.slots.length;
  const nextSlot = program.slots[nextIdx];
  if (nextSlot?.kind === 'media' && nextSlot.mediaUrl) {
    try {
      await fetchAndCache(nextSlot.mediaUrl);
    } catch (e) {
      logWarn('Preload failed', { url: nextSlot.mediaUrl, error: e.message });
    }
  }
}
